// PaginationContext.js (or whatever file you’re in)
import React, { createContext, useState } from "react";

export const PaginationContext = createContext();

export const PaginationProvider = ({ children }) => {
  const [userManagementPage, setUserManagementPage] = useState(1);
  const [activityPage, setActivityPage] = useState(1);
  const [rateMasterPage, setRateMasterPage] = useState(1);
  const [gangMasterPage, setGangMasterPage] = useState(1);
  const [employeeMasterPage, setEmployeeMasterPage] = useState(1);
  const [equipmentMasterPage, setEquipmentMasterPage] = useState(1);
  const [equipmentPage, setEquipmentPage] = useState(1);
  const [dailyActivityPage, setDailyActivityPage] = useState(1);
  const [equipmentReportsPage, setEquipmentReportsPage] = useState(1);
  const [shiftPage, setShiftPage] = useState(1);
  const [status, setStatus] = useState("new");
  const [globalSearchString, setGlobalSearchString] = useState("");
  const [customSearchPlaceholder, setCustomSearchPlaceholder] = useState("");
  const [customSearchTooltip, setCustomSearchTooltip] = useState("");

  return (
    <PaginationContext.Provider
      value={{
        userManagementPage,
        setUserManagementPage,
        activityPage,
        setActivityPage,
        rateMasterPage,
        setRateMasterPage,
        gangMasterPage,
        setGangMasterPage,
        employeeMasterPage,
        setEmployeeMasterPage,
        equipmentMasterPage,
        setEquipmentMasterPage,
        equipmentPage,
        setEquipmentPage,
        dailyActivityPage,
        setDailyActivityPage,
        equipmentReportsPage,
        setEquipmentReportsPage,
        shiftPage,
        setShiftPage,
        status,
        setStatus,
        globalSearchString,
        setGlobalSearchString,
        customSearchPlaceholder,
        setCustomSearchPlaceholder,
        customSearchTooltip,
        setCustomSearchTooltip
      }}
    >
      {children}
    </PaginationContext.Provider>
  );
};
